// Display and Hide the placeholder for Twitter on pages when the Twitter API is unavailable.
jQuery(".twitter-block-content-wrapper").bind("DOMNodeInserted", function () {
  var timeline_iframe = jQuery(".twitter-block-content-wrapper").length;
    if (timeline_iframe === 0) {
      jQuery(".twitter-block-content-wrapper").hide().css("visibility", "hidden");
      jQuery(".twitter-placeholder-wrapper").slice( 0, 1 ).show();
      jQuery(".twitter-placeholder-wrapper").slice( 1 ).hide();
    } else if (timeline_iframe > 0) {
      jQuery(".twitter-placeholder-wrapper").hide();
      jQuery(".twitter-block-content-wrapper").show();
    }
  });

jQuery(document).ready(function (jQuery) {
  var timeline_error = jQuery(".twitter-block-content-wrapper").find(".twitter-timeline-error").length;
  if (timeline_error > 0) {
    jQuery(".twitter-block-content-wrapper").hide().css("visibility", "hidden");
    jQuery(".twitter-placeholder-wrapper").slice( 0, 1 ).show();
    jQuery(".twitter-placeholder-wrapper").slice(1).hide();
  }
  
  var timeline_iframe = jQuery(".twitter-block-content-wrapper").find("iframe.twitter-timeline.twitter-timeline-rendered").length;
  if (timeline_iframe === 0) {
    jQuery(".twitter-block-content-wrapper").hide().css("visibility", "hidden");
    jQuery(".twitter-placeholder-wrapper").slice( 0, 1 ).show();
    jQuery(".twitter-placeholder-wrapper").slice( 1 ).addClass("dNone");
  } else if (timeline_iframe > 0) {
    jQuery(".twitter-placeholder-wrapper").hide();
    jQuery(".twitter-block-content-wrapper").show();
  }
});
